module.exports = __webpack_public_path__ + "img/BPPMP10.6333eca8.png";